import React from 'react'
import { CenterBox } from '@repo/ui/components/center-box'
import { Typography } from '@repo/ui/components/typography'
import { useTranslate } from '@repo/shared/hooks'
import Image from 'next/image'
import { Icon } from '@repo/ui/components'
import { ButtonLink } from '@repo/shared/components'

export const PropertiesProjectsEmptyState = ({
  isLoading,
}: {
  isLoading: boolean
}) => {
  const { t } = useTranslate()

  return (
    <CenterBox className=' flex-col gap-lg py-10xl'>
      <Image src='/images/home.webp' alt='empty-state' width={64} height={64} />
      <Typography
        variant='p'
        size='sm'
        color='text-base-surface-100'
        className='text-center'
      >
        {t('dashboardAgent_propertiesEmptyState_title')}
      </Typography>
      <ButtonLink
        variant='fill'
        size='sm'
        color='base'
        href='/projects/add'
        disabled={isLoading}
        startIcon={<Icon name='PlusLine' className='size-2' />}
      >
        {t('dashboardAgent_new_property_action')}
      </ButtonLink>
    </CenterBox>
  )
}
